import React from 'react'
import Navbar from '../components/Sidebar'
import Header from '../components/HeaderCar'

export default function PlanningArea() {
    return (
        <div>

            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container'>
                    <div className='row ps-lg-4'>
                        <h3>Planning Area</h3>
                        <div className='col-lg-8'>
                            <p>
                                Region H, located along the upper Texas coast, consists of all or part of 15 counties; Austin, Brazoria, Chambers, Fort Bend, Galveston, Harris, Leon, Liberty, Madison, Montgomery, Polk, San Jacinto, Trinity, Walker, and Waller.
                                The eastern portions of Trinity and Polk Counties are included in the Region I planning area.
                            </p>
                            <p>
                                The Region spans three rivers and four coastal basins in southeast Texas.
                                Region H encompasses the San Jacinto River Basin, the lower portions of the Trinity and Brazos River Basins, and includes part or all of the Brazos-Colorado, the San Jacinto-Brazos, the Trinity-San Jacinto, and the Neches-Trinity coastal basins.   </p>
                            <p>
                                This area includes:  the Galveston and Trinity Bay estuaries; the urbanized, rapidly growing Houston-Galveston metropolitan area encompassing Brazoria, Harris, Galveston, Fort Bend, and Montgomery Counties; the coastal port communities of Galveston and Freeport;
                                and agricultural areas in Austin, Chambers, Leon, Liberty, Madison, Polk, San Jacinto, Trinity, Walker, and Waller Counties.
                            </p>
                        </div>
                        <div className='col-lg-4 mb-3'>
                            <div className="card" style={{ backgroundColor: "#f2f2f2" }} >
                                <img alt="region-h-detail-gif" src="https://fnicdn.blob.core.windows.net/regionh/maps/thumb/Region_H-Detail.gif" className="card-img-top pt-2 px-2" />
                                <div className="card-body">
                                    <a href="https://fnicdn.blob.core.windows.net/regionh/maps/Region_H-Detail.gif" rel="noreferrer" target="_blank" className=' text-decoration-none'><h6 className="card-subtitle">Click here for a higher-resolution image of the Region H Water Planning Area</h6></a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main >

        </div >
    )
}
